// import React from "react";
// import Button from "@mui/material/Button";
// import Stack from "@mui/material/Stack";

// export default function FormActionButtons({
//   onCancel,
//   onSubmit,
//   cancelLabel = "Cancel",
//   submitLabel = "Update",
//   hideSubmit = false,
//   disableSubmit = false, // ✅ added
// }) {
//   return (
//     <Stack
//       direction="row"
//       spacing={2}
//       justifyContent="flex-end"
//       className="m-2"
//     >
//       {/* Cancel Button */}
//       <Button
//         variant="contained"
//         onClick={onCancel}
//         className="bg-rl c-r ac-btn fs-md fw-m px-3 py-2 rounded-3"
//         sx={{
//           textTransform: "none",
//           boxShadow: "none",
//           "&:hover": {
//             backgroundColor: "#FFB0A5 !important",
//           },
//         }}
//       >
//         {cancelLabel}
//       </Button>

//       {/* Submit Button */}
//       {!hideSubmit && (
//         <Button
//           variant="contained"
//           onClick={onSubmit}
//           disabled={disableSubmit} // ✅ added
//           className="bg-dg c-w ac-btn fs-md fw-m px-3 py-2 rounded-3"
//           sx={{
//             textTransform: "none",
//             boxShadow: "none",
//             "&:hover": {
//               backgroundColor: "#45728b !important",
//             },
//           }}
//         >
//           {submitLabel}
//         </Button>
//       )}
//     </Stack>
//   );
// }
import React, { useState } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export default function FormActionButtons({
  onCancel,
  onSubmit,
  cancelLabel = "Cancel",
  submitLabel = "Update",
  hideSubmit = false,
  disableSubmit = false,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await onSubmit?.();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="flex-end"
      className="m-2"
    >
      <Button
        variant="contained"
        onClick={onCancel}
        disabled={isSubmitting}
        className="bg-rl c-r ac-btn fs-md fw-m px-3 py-2 rounded-3"
      >
        {cancelLabel}
      </Button>

      {!hideSubmit && (
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={disableSubmit || isSubmitting}
          className="bg-dg c-w ac-btn fs-md fw-m px-3 py-2 rounded-3"
        >
          {isSubmitting ? "Please wait..." : submitLabel}
        </Button>
      )}
    </Stack>
  );
}